// class PDPQuickAdd extends HTMLElement {
//   constructor() {
//     super();
//     this.endpoint = "https://vapesupertore1.myshopify.com/api/2025-04/graphql.json";
//     this.publicToken = "07509e17a73d6fdb640c448a8cc2372a";

//     this.productType = this.getAttribute('data-type');
//     this.productPromoTag = this.getAttribute('data-tag');
//     this.productID = this.getAttribute('data-id');
//   }

//   async connectedCallback() {
//     this.innerHTML = `Loading products...`;
//     const allProducts = await this.getProductsWithPromo();
//     this.renderProducts(allProducts);

//     document.querySelector('.pdp__quickAds-modal-closer').addEventListener('click', (e) => {
//       document.querySelector('.pdp__quickAds-modal-container').classList.remove('open');
//     })

//     const modalContainer = document.querySelector('.pdp__quickAds-modal-container');

//     if (modalContainer) {
//       modalContainer.addEventListener('click', (e) => {
//         if (e.target.classList.contains('pdp__quickAds-modal-container')) {
//           modalContainer.classList.remove('open');
//         }
//       });
//     }
//   }

//   getRandomItems(array, count) {
//     const shuffled = [...array].sort(() => 0.5 - Math.random());
//     return shuffled.slice(0, count);
//   }

//   renderProducts(products) {
//     const container = document.createElement('div');
//     container.classList.add('pdp__quickAds-product-feed');

//     products.forEach(product => {
//       product.variants.nodes.forEach(v => {
//         const image = v.image?.url || '';
//         const price = v.price?.amount || '';
//         const variantId = v.id.split("/").pop();

//         const html = `
//           <div class="pdp__quickAds-product">
//             <div class="pdp__quickAds-product-info">
//               <div class="pdp__quickAds-product-title">${v.title}</div>
//               <div class="pdp__quickAds-product-price">£${price}</div>

//               <product-form class="product-form">
//                 <form method="post" action="/cart/add" class="form" data-type="add-to-cart-form" novalidate>
//                   <input type="hidden" name="form_type" value="product">
//                   <input type="hidden" name="utf8" value="✓">
//                   <input type="hidden" name="id" value="${variantId}">
//                   <input type="hidden" name="quantity" value="1">

//                   <div class="product-form__buttons">
//                     <button type="submit" name="add" class="product-form__submit">
//                       Add to cart
//                     </button>
//                   </div>
//                 </form>
//               </product-form>
//             </div>
//           </div>
//         `;

//         container.innerHTML += html;
//       });
//     });

//     this.innerHTML = '';
//     this.appendChild(container);
//   }



//   async getProductsWithPromo() {
//     const allProducts = [];

//       const query = `
//         query getProducts() {
//           product(id: "gid://shopify/Product/${this.productID}") {
//               id
//               title
//               handle
//               tags
//               productType
//               vendor
//               variants(first: 50) {
//                 nodes {
//                   id
//                   title
//                   image {
//                     url
//                   }
//                   price {
//                     amount
//                   }
//                 }
//               }
//           }
//         }
//       `;

//       try {
//         const response = await fetch(this.endpoint, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             "X-Shopify-Storefront-Access-Token": this.publicToken,
//           },
//           body: JSON.stringify({
//             query
//           })
//         });

//         const json = await response.json();
//         const productsData = json?.data.product;

//         allProducts.push(productsData);

//       } catch (error) {
//         console.error("Error fetching products:", error);
//       }


//     return allProducts.slice(0, 1000);
//   }
// }

// customElements.define('pdp-quick-add', PDPQuickAdd);


class PDPQuickAdd extends HTMLElement {
  constructor() {
    super();
    this.endpoint = "https://vapesupertore1.myshopify.com/api/2025-04/graphql.json";
    this.publicToken = "07509e17a73d6fdb640c448a8cc2372a";
    this.productID = this.getAttribute("data-id");
  }

  async connectedCallback() {
    this.innerHTML = `Loading products...`;
    const allProducts = await this.getProductsWithPromo();
    this.renderProducts(allProducts);

    document.querySelector(".pdp__quickAds-modal-closer")?.addEventListener("click", () => {
      document.querySelector(".pdp__quickAds-modal-container")?.classList.remove("open");
    });

    const modalContainer = document.querySelector(".pdp__quickAds-modal-container");
    if (modalContainer) {
      modalContainer.addEventListener("click", (e) => {
        if (e.target.classList.contains("pdp__quickAds-modal-container")) {
          modalContainer.classList.remove("open");
        }
      });
    }
  }

  renderProducts(products) {
    const container = document.createElement("div");
    container.classList.add("pdp__quickAds-product-feed");

    products.forEach((product) => {
      product.variants.nodes.forEach((v) => {
        const image = v.image?.url || "";
        const price = v.price?.amount || "";
        const variantId = v.id.split("/").pop();

        container.innerHTML += `
          <div class="pdp__quickAds-product">
            <div class="pdp__quickAds-product-info">
              <div class="pdp__quickAds-product-title">${v.title}</div>
              <div class="pdp__quickAds-quantity">
                <div class="pdp__quickAds-qty-control">
                  <button type="button" class="qty-decrement pdp__quickAds-qty-decrement">-</button>
                  <input
                    type="number"
                    min="0"
                    value="0"
                    class="pdp__quickAds-quantity-input"
                    data-variant-id="${variantId}"
                  />
                  <button type="button" class="qty-increment pdp__quickAds-qty-increment">+</button>
                </div>
              </div>
            </div>
          </div>
        `;
      });
    });

    this.innerHTML = "";
    this.appendChild(container);

    const formWrapper = document.createElement("div");
    formWrapper.innerHTML = `
      <product-form class="product-form">
        <form method="post" action="/cart/add" class="form" data-type="add-to-cart-form" novalidate>
          <input type="hidden" name="form_type" value="product">
          <input type="hidden" name="utf8" value="✓">
          <div class="product-form__buttons pdp__quickAds-footer">
            <button type="button" class="product-form__submit pdp__quickAds-addAllBtn button button--primary button--primary--alternate pdp_productBar-button">
              Add to cart
            </button>
          </div>
        </form>
      </product-form>
    `;
    this.appendChild(formWrapper);

    this.querySelectorAll(".pdp__quickAds-qty-control").forEach((control) => {
      const input = control.querySelector(".pdp__quickAds-quantity-input");
      const btnMinus = control.querySelector(".qty-decrement");
      const btnPlus = control.querySelector(".qty-increment");

      btnMinus.addEventListener("click", () => {
        let val = parseInt(input.value, 10);
        if (val > 0) input.value = val - 1;
      });

      btnPlus.addEventListener("click", () => {
        let val = parseInt(input.value, 10);
        input.value = val + 1;
      });
    });

    const button = formWrapper.querySelector(".pdp__quickAds-addAllBtn");
    button.addEventListener("click", async () => {
      const inputs = this.querySelectorAll(".pdp__quickAds-quantity-input");
      const items = [];

      inputs.forEach((input) => {
        const qty = parseInt(input.value, 10);
        if (qty > 0) {
          items.push({
            id: input.dataset.variantId,
            quantity: qty
          });
        }
      });

      if (items.length === 0) return;

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            items,
            sections: "cart-drawer,cart-icon-bubble",
            sections_url: window.location.pathname
          })
        });

        if (!response.ok) throw new Error("Failed to add items");

        const parsedState = await response.json();
        const cartDrawerHtml = parsedState.sections["cart-drawer"];
        const parser = new DOMParser();

        if (cartDrawerHtml) {
          const doc = parser.parseFromString(cartDrawerHtml, "text/html");
          const newElement = doc.querySelector("cart-notification-clone");
          const oldElement = document.querySelector("cart-notification-clone");

          if (oldElement && newElement) {
            oldElement.updateCartDrawerDOM(newElement, true);
          }
        }

        const cartIconBubbleHtml = parsedState.sections["cart-icon-bubble"];

        if (cartIconBubbleHtml) {
          const newBubbleDoc = parser.parseFromString(cartIconBubbleHtml, "text/html");
          const oldBubble = document.getElementById("cart-icon-bubble");
          const newBubble = newBubbleDoc.getElementById("cart-icon-bubble") || newBubbleDoc.querySelector(".shopify-section");

          if (oldBubble && newBubble) {
            oldBubble.innerHTML = newBubble.innerHTML;
          }
        }

        document.querySelector(".pdp__quickAds-modal-container")?.classList.remove("open");
      } catch (error) {
        console.error("Add to cart error:", error);
        window.location.href = "/cart";
      }
    });
  }

  async getProductsWithPromo() {
    const query = `
      query getProducts {
        product(id: "gid://shopify/Product/${this.productID}") {
          id
          title
          handle
          variants(first: 50) {
            nodes {
              id
              title
              image { url }
              price { amount }
            }
          }
        }
      }
    `;

    try {
      const response = await fetch(this.endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Shopify-Storefront-Access-Token": this.publicToken,
        },
        body: JSON.stringify({ query }),
      });

      const json = await response.json();
      return [json?.data?.product].filter(Boolean);
    } catch (error) {
      console.error("Error fetching products:", error);
      return [];
    }
  }
}

customElements.define("pdp-quick-add", PDPQuickAdd);





class PDPQuickAddOpen extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (e) => {
      document.querySelector('.pdp__quickAds-modal-container').classList.add('open');
    })

  }
}

customElements.define('pdp-quick-add-open', PDPQuickAddOpen);
